import React, { useState, useEffect, useRef } from 'react';

import { useDebounce } from 'modules/shared/hooks';

import { ProductQuantitySelectorProps } from './product-quantity-selector-type';

import styles from './product-quantity-selector-component.module.css';

export const ProductQuantitySelector: React.FC<ProductQuantitySelectorProps> = ({
    quantity,
    minQuantity,
    onQuantityChange,
}: ProductQuantitySelectorProps) => {
    const [localQuantity, setLocalQuantity] = useState(0);
    const debouncedQuantity = useDebounce(localQuantity, 800);
    const refQuantity = useRef(0);
    const isFirstRun = useRef(true);

    useEffect(() => {
        refQuantity.current = quantity;
        setLocalQuantity(quantity);
    }, [quantity]);

    useEffect(() => {
        if (!isFirstRun.current && debouncedQuantity !== refQuantity.current) {
            onQuantityChange(debouncedQuantity);
        } else {
            isFirstRun.current = false;
        }
    }, [debouncedQuantity, onQuantityChange]);

    return (
        <div className={styles.manageProduct}>
            <span>Qté :</span>
            <button
                className={`${styles.priceBtn} ${
                    localQuantity && localQuantity > 0 && !(minQuantity && minQuantity === localQuantity)
                        ? ''
                        : styles.hiddenButton
                }`}
                onClick={() => {
                    setLocalQuantity(localQuantity - 1);
                }}
                type="button"
            >
                −
            </button>
            <h5 className={styles.quantityValue}>{localQuantity}</h5>
            <button
                className={styles.priceBtn}
                onClick={() => {
                    setLocalQuantity(localQuantity + 1);
                }}
                type="button"
            >
                +
            </button>
        </div>
    );
};
